import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { ApiService } from "@app/services/api/api.service";
import { UserService } from "@app/services/user/user.service";
import { MenuItem } from "primeng/api";
import { VesselGroupsService } from "@app/services/vessel-groups/vessel-groups.service";

@Component({
  selector: "app-fleet-status",
  templateUrl: "./fleet-status.component.html",
  styleUrls: ["./fleet-status.component.scss"],
})
export class FleetStatusComponent implements OnInit, OnDestroy {
  private clientName: string = "";
  private subscriptions: Subscription[] = [];
  data = [];

  vesselGroups: MenuItem[] = [];
  expandedRows: {};

  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private vesselGroupsService: VesselGroupsService
  ) {}

  ngOnInit() {
    this.apiService
      .initialize()
      .toPromise()
      .then(() => {
        this.subscriptions.push(
          this.userService.initialize().subscribe({
            next: () => {
              this.clientName = this.userService.getClientDetail("name") ?? "";
            },
          })
        );
      });

    this.subscriptions.push(
      this.vesselGroupsService.initialize().subscribe({
        next: () => {
          const vesselGroups = this.vesselGroupsService.getVesselGroups();
          this.vesselGroups = [];
          vesselGroups.forEach((group) => {
            const vessels = group._embedded["fo:vessels"];
            if (vessels && vessels.length > 0) {
              const vesselGroup = {
                label: group.name,
                vessels: [],
              };
              vessels.forEach((vessel) => {
                vesselGroup.vessels.push({
                  imo: vessel.imo,
                  label: vessel.name,
                  ciiRating: vessel.ciiRating,
                  overConsumption_ratio: vessel.overConsumption_ratio,
                  manualReportDataUtc: vessel.manualReportDataUtc,
                  manualReportDataUpToDate: vessel.manualReportDataUpToDate,
                  sensorDataUtc: vessel.sensorDataUtc,
                  sensorDataUpToDate: vessel.sensorDataUpToDate,
                });
              });
              this.vesselGroups.push(vesselGroup);
            }
          });
          this.expandedRows = this.vesselGroups.reduce((acc, vesselGroup) => (acc[vesselGroup.label] = true) && acc, {});
        },
      })
    );
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  getClientName() {
    return this.clientName;
  }

  isLoading() {
    return this.vesselGroupsService.loading;
  }
}
